import {
  OrganizationErrors,
  OrganizationErrorExtensions,
} from './organizations';
import { PaidAccountErrorExtensions } from './paidAccount';
import { PluginErrorExtensions } from './plugins';
import { PromoCodeErrorExtensions } from './promoCodes';
import { PromotionErrorExtensions } from './promotions';
import { ActionErrorExtensions } from './action';
import { BoardErrors, BoardErrorExtensions } from './boards';
import { RequestAccessErrors, RequestAccessExtensions } from './requestAccess';

enum UnknownErrorExtensions {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export const Errors = {
  ...BoardErrors,
  ...OrganizationErrors,
  ...RequestAccessErrors,
} as const;

export const ErrorExtensions = {
  ...OrganizationErrorExtensions,
  ...PaidAccountErrorExtensions,
  ...PluginErrorExtensions,
  ...PromoCodeErrorExtensions,
  ...PromotionErrorExtensions,
  ...ActionErrorExtensions,
  ...BoardErrorExtensions,
  ...RequestAccessExtensions,
  ...UnknownErrorExtensions,
} as const;

export type ErrorType = keyof typeof Errors;
export type ErrorExtensionsType = keyof typeof ErrorExtensions;
export {
  OrganizationErrors,
  OrganizationErrorExtensions,
  PaidAccountErrorExtensions,
  BoardErrorExtensions,
  RequestAccessExtensions,
};
